const dataLakeEnumerators = {
  type: [
    'absence',
    'absence_structure',
    'employee',
    'employee_structure',
    'achs',
    'achs_structure',
    'overtime',
    'overtime_structure',
    'resumen-produccion',
    'resumen-produccion_structure',
    // 'guia_traslado',
    // 'guia_traslado_structure',
  ],
};

export default dataLakeEnumerators;
